/*
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav P�ibyl (pribyl@cadwork.cz)
 *
 */

import RenderDocument from "App/render_document";
import {vec3, vec4} from "gl-matrix";
import IScene from "js_interface/src/scene_interface";

export default
class Light {

    public static TypeName: string = "Light";
    private static lightUID: number = 0; // generator

    protected _sceneAPI: IScene;
    protected _position: vec4 = vec4.fromValues(1.0, 1.0, 0.0, 0.0); // the 4th component 0.0 is for directional light
    protected diffuseColor: vec3 = vec3.fromValues(1.0, 1.0, 1.0);
    protected specularColor: vec3 = vec3.fromValues(1.0, 1.0, 1.0);
    protected _enabled: number = 1;
    protected positionFixed: boolean = false;
    protected intenzity: number = 1.0;
    protected _tmpVec3: vec3 = vec3.create();
    protected _tmpVec4: vec4 = vec4.create();
    protected _typeName: string = Light.TypeName;

    private _ID: number = Light.lightUID++;

    constructor(aRenderDocument: RenderDocument) {
        this._sceneAPI = aRenderDocument.getSceneAPI();
    }

    public getTypeName(): string {
        return this._typeName;
    }

    public getUID(): number {
        return this._ID;
    }

    public getPosition(): vec4 {
        return vec4.copy(this._tmpVec4, this._position);
    }

    public setPositionFixed(aValue: boolean) {
        this.positionFixed = aValue;
    }

    public getPositionFixed(): boolean {
        return this.positionFixed;
    }

    public enable(aValue: boolean) {
        this._enabled = aValue ? 1 : 0;
    }

    public getEnabledValue(): number {
        return this._enabled;
    }

    public getDiffuseColor(): vec3 {
        return vec3.scale(this._tmpVec3, this.diffuseColor, this.intenzity);
    }

    public getSpecularColor(): vec3 {
        return vec3.scale(this._tmpVec3, this.specularColor, this.intenzity);
    }

    protected setPosition(aPosition: vec4) {
        vec4.copy(this._position, aPosition);
    }

    private setIntenzity(aValue: number) {
        this.intenzity = aValue;
    }
}
